module.exports = __webpack_public_path__ + "fonts/NoirPro-Heavy.7194b3b5.eot";